import { InstanceHelper } from "~/helpers/instanceHelper";
import { IDynamicFieldsElementOptions } from "~/interfaces/dynamicFieldsElementOptionsInterfaces";
import { IDynamicDataConfig, IDynamicTreeContext } from '~/interfaces/dynamicFieldsInterfaces'
import { Hash } from "~/interfaces/hashInterfaces";
import Formula from "~/models/formula";

export default class DynamicFieldsHandler {
  showDynamicMessage: boolean = false;
  dynamicMessage: string;
  SECTIONS: string[] = [];
  elementOptions: IDynamicFieldsElementOptions;
  pillColor: string;
  // was almost used at one point to store additional info about formulas
  // @type {Function} a function that will return an object with data to attach to generated pill
  meta: string | ((selectedItem) => string) = null

  constructor(options: Hash = {}) {
    this.pillColor = options.pillColor;
    if (typeof options.meta === 'function' || typeof options.meta === 'string') {
      this.meta = options.meta
    }
  }

  shouldShow(section: string, q: string): boolean {
    return this.SECTIONS.includes(section);
  }

  getAll(area?: string): DynamicFieldsHandler[] {
    return [this];
  }

  /**
   * Override in subclasses where necessary to determine if item should be disabled
   * @param item the item to potentially disable in the tree
   * @protected
   */
  protected isDisabled(item: object): boolean {
    return false;
  }

  /**
   * Override in subclasses to add tooltip
   */
  tooltipMessage(item: object, context: Partial<IDynamicTreeContext<any>> = {}): string {
    return null
  }

  /**
   * The general function that will take the #getMeta result and merge it with subclass data id
   * @param selectedItem the item selected for the pill
   * @param subclassData created in subclass to attach to pill
   */
  protected select(selectedItem: object, subclassData: IDynamicDataConfig): IDynamicDataConfig {
    const meta = this.getMeta(selectedItem)
    if (InstanceHelper.isPresent(meta) && subclassData.id) {
      subclassData.id = Formula.buildDynamicId({id: subclassData.id, meta: meta}) // add meta data to id - wysiwyg pills aren't saved for formulas, must have way to save meta data
    }
    return subclassData
  }

  /**
   * The function used in the standard #select function the runs the optional "meta" function on the handler
   *   this is primarily used in select function to run the passed in meta function and attach results to id
   *   that will be passed to the dynamic data on the pill
   * @see select
   * @param selectedItem the item that was selected for the pill
   * @return the evaluation of the #meta function as a starter for what gets sent to the dynamic pill
   */
  private getMeta(selectedItem): string {
    if (typeof this.meta === 'function') {
      return this.meta(selectedItem)
    } else if (typeof this.meta === 'string') {
      return this.meta
    }
  }

  protected qMatches(q: string, testString: string): boolean {
    return testString.toLowerCase().match(q) !== null;
  }
};